<template>
    <div v-if="status">
        <IndependentAcceleratorsView />
        <ReportTemplate :table-props="apiColumns" :project-param-id="projectParamId" :api-param-id="apiParamId" />
    </div>
</template>

<script>
import ReportTemplate from "@/components/ReportTemplate.vue";
import { pageViews, type } from "../utils/util";
import Store from "../vuex/store.js";
import IndependentAcceleratorsView from "./IndependentAcceleratorsView.vue";

export default {
    name: pageViews.APIVIEW,
    methods: {
        setValuesToStore(type) {
            Store.commit("setType", type);
        },
    },
    mounted() {
        this.setValuesToStore(type.API);
    },
    components: {
      ReportTemplate,
      IndependentAcceleratorsView
    },
    data() {
        return {
        status: true,
        uploadConfigs: {
            action: "generator",
            actionLabel: "Generator",
            title: "API",
            type: type.API,
            accept: ".zip",
        },
        apiColumns: {
            type: type.API,
            isMultiSelectionAllowed: true,
            configs: [
            {
              name: "apiId",
              label: "API ID",
              order: 2,
            },
            {
                name: "requestDate",
                label: "Request Date",
                order: 1,
                type: "date",
                search: false,
                defaultSelected: true
            },
            {
                name: "fileName",
                label: "File Name",
                order: 4,
                checked: true,
                defaultSelected: true,
                textAlign: "left",
            },
            {
                name: "status",
                label: "Status",
                order: 5,
                search: false,
                defaultSelected: true
            },
            {
                name: "lastModifiedDate",
                label: "Last Modified Date",
                order: 6,
                type: "date",
                search: false
            },
            {
                name: "totalApis",
                label: "Total APIs",
                order: 7,
                search: false,
                defaultSelected: true
            },
            {
                name: "soapApis",
                label: "SOAP APIs",
                order: 8,
                search: false,
                defaultSelected: true
            },
            {
                name: "restApis",
                label: "REST APIs",
                order: 9,
                search: false,
            },
            {
                name: "processedApisList",
                label: "Processed APIs List",
                order: 10,
                search: false,
                textAlign: "left",
                textOverflowStyle: "ellipsis",
            },
            {
                name: "failedApis",
                label: "Failed APIs",
                order: 11,
                search: false,
            },
            {
                name: "failedApisList",
                label: "Failed APIs List",
                order: 12,
                search: false,
                textAlign: "left",
                textOverflowStyle: "ellipsis",
            },
            {
                name: "remarks",
                label: "Remarks",
                order: 13,
                search: false,
                textAlign: "left",
                textOverflowStyle: "ellipsis",
            }
            ],
            actions: {
            download: {
                label: 'Request Download'
            },
            }
        }  
        };
    },
    props: ["projectParamId", "apiParamId"],
}

</script>
